export default "__VITE_ASSET__BRJId05d__"